import { CultureInfo } from '../culture-info.model';
import { CultureInfoMsArab } from './ms-Arab';

/**
 * @ignore
 */
export const CultureInfoMsArabBN: CultureInfo = {
  name: 'ms-Arab-BN',
  displayName: 'بهاس ملايو (عرب، بروني)',
  iso3LanguageCode: 'msa',
  iso2LanguageCode: 'ms',
  ietfLanguageTag: 'ms-Arab-BN',
  parent: CultureInfoMsArab
};
